import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { Template } from '../types';
import templateApi from '../services/templateApi';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';

export const BaseQueryKey = 'templates';

const byModifiedTime = (a: Template, z: Template) => {
  if (!a.modified_time && !z.modified_time) return 0;
  if (!z.modified_time) return 1;
  if (!a.modified_time) return -1;
  return a.modified_time.getTime() - z.modified_time.getTime();
};

export const useTemplates = (statuses: string[]) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();

  return useQuery(
    [BaseQueryKey, statuses],
    async () => {
      const templates = await templateApi.getTemplatesByCompanyIdAndStatuses(companyId, statuses);
      return [...templates].sort(byModifiedTime);
    },
    {
      onError: (error) => {
        showToast({
          description: formErrorMessageForToast(t('template.hooks.fetchAll.error'), error),
          status: 'error',
          title: t('common.toast.error'),
          'data-cy': 'toast-fetch-templates-error',
        });
      },
    },
  );
};
